module.exports = __webpack_public_path__ + "b8802b6809309047bc4be3ce78db073b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./public/bg12.jpeg
// module id = 20
// module chunks = 0